import React from 'react';
import './Navbar.css';

function Navbar() {
    const handleNavClick = (e, targetId) => {
        e.preventDefault();
        const target = document.querySelector(targetId);
        if (target) {
            target.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <nav>
            <a href="/" className="nav-logo">
                <div className="nav-logo-mark">
                    <svg viewBox="0 0 24 24" fill="none" stroke="#60A5FA" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <circle cx="12" cy="12" r="3"/>
                        <path d="M12 2v3M12 19v3M4.22 4.22l2.12 2.12M17.66 17.66l2.12 2.12M2 12h3M19 12h3M4.22 19.78l2.12-2.12M17.66 6.34l2.12-2.12"/>
                    </svg>
                </div>
                <span className="nav-logo-text">AIColl</span>
            </a>

            <ul className="nav-links">
                <li><a href="#services" onClick={(e) => handleNavClick(e, '#services')}>Услуги</a></li>
                <li><a href="#product" onClick={(e) => handleNavClick(e, '#product')}>Продукт</a></li>
                <li><a href="#tech" onClick={(e) => handleNavClick(e, '#tech')}>Технологии</a></li>
                <li><a href="/app.html" className="nav-cta">Войти в Колледж Плюс</a></li>
            </ul>
        </nav>
    );
}

export default Navbar;